import React, { ReactNode } from "react";
import styles from './Spacing.module.css';

type Spacing = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type SpacingProps = {
  children?: ReactNode;
  direction?: 'horizontal' | 'vertical';
  spacing?: Spacing;
  spaceBetween?: boolean
};

export const Spacing = ({ children, direction = "vertical", spacing = 6, spaceBetween = false }: SpacingProps) => {
  let className = '';
  switch(direction){
    case 'horizontal':
      className = `${styles['spacing-'+spacing.toString()]} ${styles.horizontal}`;
      break;
    case 'vertical':
      className = `${styles['spacing-'+spacing.toString()]} ${styles.vertical}`;
      break;
  }
  
  return <div className={`${className} ${spaceBetween && styles.spaceBetween}`}>{children}</div>;
};